import CryptoJS from 'crypto-js';

const rawKey = process.env.REACT_APP_ENCRYPTION_KEY;
const rawIv = process.env.REACT_APP_ENCRYPTION_IV;

const key = CryptoJS.SHA256(rawKey).toString(CryptoJS.enc.Hex).substring(0, 32);
const iv = CryptoJS.SHA256(rawIv).toString(CryptoJS.enc.Hex).substring(0, 16);

export function decrypt(encryptedBase64) {
    const keyWords = CryptoJS.enc.Utf8.parse(key);
    const ivWords = CryptoJS.enc.Utf8.parse(iv);
 
    const decrypted = CryptoJS.AES.decrypt(encryptedBase64, keyWords, {
        iv: ivWords,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
 
    return decrypted.toString(CryptoJS.enc.Utf8);
}
